import React, { useState } from "react";

import { useJobs } from "../../state/Storage";
import { getUser } from "../../state/User";
import { sortByDate, jobsToBuckets, keyToFormattedDate } from "../helpers";
import Activity from "../utils/icons/Activity";
import Pagination from "../utils/Pagination";
import JobPreview from "./JobPreview";

export default function CampaignTimeline({
  campaign,
  jobsManager,
}: {
  campaign: Post;
  jobsManager: JobsManager;
  key?: string;
}) {
  const [jobs, sync, pagination] = jobsManager;
  const [deletionError, setDeletionError] = useState(null);
  const user = getUser() as User;
  const jobsForThisPost = jobs
    .filter((j) => j.postId === campaign.id)
    .sort(sortByDate);
  const buckets = jobsToBuckets(jobsForThisPost);

  return (
    <div className="jobs">
      <div className="layout">
        {deletionError && <p className="error mt2">{deletionError.message}</p>}
        <ul>
          {buckets.length > 0 &&
            buckets.map((bucket) => {
              const { jobs, key } = bucket;
              const engagements = jobs.reduce(
                (res, j) => (j.stats ? res + j.stats.engagements : res),
                0
              );

              return (
                <React.Fragment key={key}>
                  <li>
                    <div></div>
                    <div className="op06 tac pr1">
                      <small>{keyToFormattedDate(key)}</small>
                      {engagements > 0 ? (
                        <small className="ib ml1">
                          <Activity size={12} /> {engagements}
                        </small>
                      ) : null}
                    </div>
                  </li>
                  {jobs.map((j: Job) => (
                    <JobPreview
                      key={j.id}
                      job={j}
                      post={campaign}
                      user={user}
                      setDeletionError={setDeletionError}
                      onDelete={sync}
                    />
                  ))}
                </React.Fragment>
              );
            })}
        </ul>
        {buckets.length > 0 && <Pagination pagination={pagination} />}
      </div>
    </div>
  );
}
